import { canUseDOM } from 'exenv';
import P from 'bluebird';

import loadGATracker from './ga';
import loadFacebookTracker from './facebook';
import loadOmnitureTracker from './omniture';
import loadComscoreTracker from './comscore';
import loadNielsenTracker from './nielsen';
import loadKruxTracker from './krux';
import loadParselyTracker from './parsely';
import loadLiftIgniterTracker from './liftIgniter';
import featureFlags from '../../../../feature_flags';

// The following trackers are executed on CLIENT SIDE ONLY
// Usually during single page app's "pageview" action
export default function trackThirdPartyJS(currentState, pageNumber) {
  if (canUseDOM) {
    const trackers = [
      loadGATracker(currentState, pageNumber),
      loadFacebookTracker(currentState),
      loadOmnitureTracker(currentState, pageNumber),
      loadComscoreTracker(currentState),
      loadNielsenTracker(),
      loadKruxTracker(currentState),
      loadParselyTracker(currentState)
    ];

    if (featureFlags.liftIgniterEnabled) {
      trackers.push(loadLiftIgniterTracker(currentState));
    }

    return P.all(trackers);
  }
  return P.resolve([]);
}



// WEBPACK FOOTER //
// ./src/client/utils/third_party_trackers/trackThirdPartyJS.js